
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buying-terms",
      function () {
        return require("private-next-pages/buying-terms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buying-terms"])
      });
    }
  